import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';

const TransferPanelFeesDetails = ({
  contraAccount,
  type,
  accountSideDescription,
  contraAccountSideDescription,
}) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.feeType} />}
      data={type}
      dataTestHandle="feeDetails__feeType"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.feeContraAccount} />}
      data={contraAccount}
      dataTestHandle="feeDetails__feeContraAccount"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.feeAccountSideDescription} />}
      data={accountSideDescription.map((description, index) => (index === 0 ? description : <div>{description}</div>))}
      dataTestHandle="feeDetails__feeAccountSideDescription"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.feeContraAccountSideDescription} />}
      data={contraAccountSideDescription.map((description, index) => (index === 0 ? description : <div>{description}</div>))}
      dataTestHandle="feeDetails__feeContraAccountSideDescription"
    />
  </div>
);

TransferPanelFeesDetails.propTypes = {
  contraAccount: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  accountSideDescription: PropTypes.array.isRequired,
  contraAccountSideDescription: PropTypes.array.isRequired,
};

export default TransferPanelFeesDetails;



// WEBPACK FOOTER //
// ./src/components/transferPanelFeesDetails/index.js